import React from "react";
import { NavLink } from "react-router-dom";
import { ListMinus, Users, Settings, Headphones } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ADMIN_TABS = [
  { to: "/appels", label: "Appels", icon: ListMinus, testid: "mobilenav-calls" },
  { to: "/contacts", label: "Contacts", icon: Users, testid: "mobilenav-contacts" },
  { to: "/parametres", label: "Réglages", icon: Settings, testid: "mobilenav-settings" },
];

// Agents: Appels, Contacts, Mon poste (Réglages is admin-only).
const AGENT_TABS = [
  { to: "/appels", label: "Appels", icon: ListMinus, testid: "mobilenav-calls" },
  { to: "/contacts", label: "Contacts", icon: Users, testid: "mobilenav-contacts" },
  { to: "/mon-poste", label: "Mon poste", icon: Headphones, testid: "mobilenav-my-station" },
];

export const MobileBottomNav = () => {
  const { isAdmin } = useAuth();
  const tabs = isAdmin ? ADMIN_TABS : AGENT_TABS;
  return (
    <nav
      data-testid="mobile-bottomnav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 pb-safe"
    >
      <div className="grid grid-cols-3 h-16">
        {tabs.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 min-h-[44px] ${
                isActive ? "text-emerald-600" : "text-slate-400"
              }`
            }
          >
            <Icon className="h-[22px] w-[22px]" strokeWidth={2} />
            <span className="text-[11px] font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
